export const containsOneAt = (email = "") => email.replace(/[^@]/g, "").length === 1;
